import React from 'react';
import { Table } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ClientHubPosVendaProtocoloDto } from '../../types/posVenda';
import { labelStatusProtocolo } from '../../utils/posVenda/posVendaEnumDisplay';
import { labelTipoProtocolo } from '../../utils/posVenda/posVendaLabels';
import SlaBadge from '../../pages/PosVenda/components/SlaBadge';

interface ClientHubProtocolosTableProps {
  clientId: string;
  protocolos: ClientHubPosVendaProtocoloDto[];
  onBeforeNavigate?: () => void;
}

export const ClientHubProtocolosTable: React.FC<ClientHubProtocolosTableProps> = ({
  clientId,
  protocolos,
  onBeforeNavigate,
}) => {
  const navigate = useNavigate();
  const { hasRole } = useAuth();
  const podeAbrir = hasRole('Admin');

  if (protocolos.length === 0) {
    return <p style={{ color: '#667', margin: 0 }}>Nenhum protocolo de pós-venda registrado.</p>;
  }

  return (
    <Table celled compact selectable size="small">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Protocolo</Table.HeaderCell>
          <Table.HeaderCell>Tipo</Table.HeaderCell>
          <Table.HeaderCell>Status</Table.HeaderCell>
          <Table.HeaderCell>SLA</Table.HeaderCell>
          <Table.HeaderCell>Responsável</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {protocolos.map((p) => (
          <Table.Row
            key={p.id}
            style={{ cursor: podeAbrir ? 'pointer' : 'default' }}
            onClick={() => {
              if (!podeAbrir) return;
              onBeforeNavigate?.();
              navigate(
                `/pos-venda?clientId=${encodeURIComponent(clientId)}&protocoloId=${encodeURIComponent(p.id)}`
              );
            }}
          >
            <Table.Cell>
              <strong>{p.numero}</strong>
            </Table.Cell>
            <Table.Cell>{labelTipoProtocolo(p.tipo)}</Table.Cell>
            <Table.Cell>{labelStatusProtocolo(p.status)}</Table.Cell>
            <Table.Cell>
              <SlaBadge estado={p.slaEstado} percentual={p.slaPercentualConsumido} status={p.status} />
            </Table.Cell>
            <Table.Cell>{p.responsavelNome ?? '—'}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default ClientHubProtocolosTable;
